import { isNextApp } from "utils-lib/isNextApp"

export default () => {
  const alertVersion = isNextApp
    ? process.env.NEXT_PUBLIC_ALERT_VERSION
    : process.env.REACT_APP_ALERT_VERSION

  return alertVersion
}
